import { useState } from 'react';
import Card from '../../components/Card';
import AreaChart from '../../components/AreaChart';
// import useHistoricalTVL from '../../hooks/analytics/useHistoricalTVL';
import useMockHistoricalTVL from '../../hooks/analytics/useMockHistoricalTVL';
import { config } from '../../config/config';
import { ValueOf } from '../../config/constants';

const TotalValueLocked = () => {
    const [timeframeOption, setTimeframeOption] =
        useState<ValueOf<typeof config.areaChartTimeframes>>('1d');
    const [activePayload, setActivePayload] = useState<number | undefined>();
    // const { historicalTVL, defaultData, isLoading } = useHistoricalTVL(
    //     timeframeOption as any
    // );
    const { historicalTVL, defaultData, isLoading } = useMockHistoricalTVL(
        timeframeOption as any
    );

    const handlePayloadChange = (newPayload: number | undefined) => {
        if (newPayload !== activePayload) {
            setActivePayload(newPayload);
        }
    };

    const handleTimeframeChange = (
        newTimeframe: ValueOf<typeof config.areaChartTimeframes>
    ) => {
        setTimeframeOption(newTimeframe);
    };

    return (
        <Card className='large-card'>
            <AreaChart
                isLoading={isLoading}
                data={historicalTVL ?? defaultData}
                withKpi
                activePayload={historicalTVL ? activePayload : undefined}
                onActivePayloadChange={handlePayloadChange}
                label='Total Value Locked'
                activePayloadLabel='Total Value Locked'
                withTimeFrames
                timeframes={config.areaChartTimeframes}
                onTimeframeChange={(timeframe) => handleTimeframeChange(timeframe)}
            />
        </Card>
    );
};
export default TotalValueLocked;
